export const VESSELS_STORE_ID = 'VesselsStore';
